import React from 'react'

function FooterGroup({ label, children }) {
  return (
    <div className="flex items-center gap-x-4">
      <span className="text-[11px] font-medium uppercase tracking-widest text-gray-500 whitespace-nowrap">
        {label}
      </span>
      <div className="flex items-center gap-x-4">{children}</div>
    </div>
  )
}

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-6" style={{ filter: 'grayscale(1)' }}>
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-between gap-x-10 gap-y-5">
          <FooterGroup label="Realização">
            <img
              src="/images/footer/fau-mack.png"
              alt="Mackenzie — Faculdade de Arquitetura e Urbanismo"
              className="h-9 w-auto object-contain sm:h-10"
            />
            <span className="text-xl font-extrabold text-gray-900 whitespace-nowrap sm:text-2xl">
              LabUrBE
            </span>
          </FooterGroup>

          <FooterGroup label="Parceria">
            <img
              src="/images/footer/mackleaps.png"
              alt="Mackleaps"
              className="h-9 w-auto object-contain sm:h-10"
            />
            <span className="flex items-center gap-x-2">
              <img
                src="/images/footer/mack-m.png"
                alt="Mackenzie"
                className="h-8 w-auto object-contain sm:h-9"
              />
              <span className="text-sm font-bold leading-tight text-gray-900">
                Laboratório de
                <br />
                Geotecnologias
              </span>
            </span>
          </FooterGroup>

          <FooterGroup label="Fomento">
            <img
              src="/images/footer/mackpesquisa.png"
              alt="Mackenzie — MackPesquisa"
              className="h-9 w-auto object-contain sm:h-10"
            />
            <img
              src="/images/footer/acsp.png"
              alt="Associação Comercial de São Paulo"
              className="h-9 w-auto object-contain sm:h-10"
            />
            <img
              src="/images/footer/cpu.png"
              alt="CPU"
              className="h-9 w-auto object-contain sm:h-10"
            />
          </FooterGroup>

          <div className="text-sm text-gray-700 whitespace-nowrap">
            contato:{' '}
            <a
              href="mailto:polosvarejistas@gmail.com"
              className="text-gray-900 hover:underline"
            >
              polosvarejistas@gmail.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
